import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalization } from "../../localization/LocalizationContext";
import VlanNetworkSetup from "./vlanNetworkSetup";
import PortConfiguration from "./portConfiguration";
import DowntimeSchedules from "./downtimeSchedules";
import RadiusConfiguration from "./radiusConfiguration";
import CableTest from "./cableTest";
import ResetCounters from "./resetCounters";
import IPSettings from "./ipSettings";

const TABS = [
  {
    group: "Network",
    items: [
      { id: "vlanSetup", labelKey: "vlanNetworkSetup", fallback: "VLAN / Network setup" },
      { id: "poeDowntime", labelKey: "poeDowntimeSchedule", fallback: "PoE downtime schedule" },
      { id: "ipSettings", labelKey: "ipSettings", fallback: "IP settings" },
      { id: "radiusConfig", labelKey: "radiusConfiguration", fallback: "RADIUS configuration" },
    ],
  },
  {
    group: "Diagnostics",
    items: [
      { id: "cableTest", labelKey: "cableTest", fallback: "Cable test" },
    ],
  },
];

function WiredConfiguration() {
  const navigate = useNavigate();
  const { localizationStrings } = useLocalization();
  const [activeTab, setActiveTab] = useState("vlanSetup");
  const [scheduleModal, setScheduleModal] = useState(false);

  const current = TABS.flatMap((group) => group.items).find((tab) => tab.id === activeTab);
  const currentTitle =
    localizationStrings?.[current?.labelKey] || current?.fallback || localizationStrings?.wiredConfiguration;

  return (
    <div className="nms-dash config-page">
      <div className="inc-card ch-100">
        <div className="inc-card-title">
          <h3>{currentTitle}</h3>
          <div className="inc-card-button">
            <button className="btn btn-outline" onClick={() => navigate("/wired")}>
              {localizationStrings?.quickView}
            </button>
            {activeTab === "vlanSetup" && (
              <button
                className="text-btn primary-btn"
                onClick={() => navigate("/configureNetwork")}
              >
                <i className="fa fa-plus" aria-hidden="true" />{" "}
                {localizationStrings?.createVlan || "Create VLAN"}
              </button>
            )}
            {activeTab === "poeDowntime" && (
              <button
                className="text-btn primary-btn"
                onClick={() => setScheduleModal(true)}
              >
                <i className="fa fa-plus" aria-hidden="true" /> Add schedule
              </button>
            )}
          </div>
        </div>
        <div className="inc-card-body">
          <div className="sideTab-container wired-sideTab">
            <div className="inc-side-tab">
              {TABS.map((group) => (
                <div key={group.group}>
                  <div className="config-nav-group">{group.group}</div>
                  <ul className="nav-side">
                    {group.items.map((tab) => (
                      <li key={tab.id}>
                        <button
                          type="button"
                          className={`config-nav-item${activeTab === tab.id ? " active" : ""}`}
                          onClick={() => setActiveTab(tab.id)}
                        >
                          {localizationStrings?.[tab.labelKey] || tab.fallback}
                          <i className="fa fa-angle-right" aria-hidden="true" />
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
            <div className="inc-side-tabcontainer">
              {activeTab === "vlanSetup" && <VlanNetworkSetup />}
              {activeTab === "portConfig" && <PortConfiguration />}
              {activeTab === "poeDowntime" && (
                <DowntimeSchedules
                  scheduleModal={scheduleModal}
                  setScheduleModal={setScheduleModal}
                />
              )}
              {activeTab === "cableTest" && <CableTest />}
              {activeTab === "radiusConfig" && <RadiusConfiguration />}
              {activeTab === "resetCounters" && <ResetCounters />}
              {activeTab === "ipSettings" && <IPSettings />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WiredConfiguration;
